<div class="card m-0 bg-transparent">
  <div class="card-body">
    <form [formGroup]="labelform">

      <!-- Row Position -->
      <div class="col-12 mb-3">
        <label class="offcanvas-header-text w-100 text-start mb-2">
          {{ config?.name }}
        </label>
        <div class="row g-2">
          <div class="col-3" *ngFor="let p of positionOptions">
            <button
              type="button"
              class="btn w-100 d-flex flex-column align-items-center gap-1 py-2 px-1"
              [class.btn-outline-secondary]="labelform.get('position')?.value !== p.key"
              [class.btn-outline-primary]="labelform.get('position')?.value === p.key"
              (click)="selectPosition(p.key)"
            >
              <svg width="32" height="28" viewBox="0 0 28 28" fill="none">
                <ng-container [ngSwitch]="p.key">

                  <ng-container *ngSwitchCase="'single'">
                    <rect x="3" y="10" width="22" height="8" rx="2"
                      [attr.fill]="labelform.get('position')?.value === p.key ? 'rgba(13,110,253,0.3)' : '#333'"
                      [attr.stroke]="labelform.get('position')?.value === p.key ? '#0d6efd' : '#444'"
                      stroke-width="1.2"/>
                  </ng-container>

                  <ng-container *ngSwitchCase="'top'">
                    <rect x="3" y="4" width="22" height="8" rx="2"
                      [attr.fill]="labelform.get('position')?.value === p.key ? 'rgba(13,110,253,0.3)' : '#333'"
                      [attr.stroke]="labelform.get('position')?.value === p.key ? '#0d6efd' : '#444'"
                      stroke-width="1.2"/>
                    <rect x="3" y="14" width="22" height="2" rx="1"
                      [attr.fill]="labelform.get('position')?.value === p.key ? '#f88' : '#666'"
                      opacity="0.6"/>
                    <rect x="3" y="18" width="22" height="6" rx="2" fill="#2a2a3a"
                      [attr.stroke]="labelform.get('position')?.value === p.key ? '#6ea8fe' : '#555'"
                      stroke-width="1" stroke-dasharray="2 2"/>
                  </ng-container>

                  <ng-container *ngSwitchCase="'middle'">
                    <rect x="3" y="2" width="22" height="6" rx="2" fill="#2a2a3a"
                      [attr.stroke]="labelform.get('position')?.value === p.key ? '#6ea8fe' : '#555'"
                      stroke-width="1" stroke-dasharray="2 2"/>
                    <rect x="3" y="10" width="22" height="2" rx="1"
                      [attr.fill]="labelform.get('position')?.value === p.key ? '#f88' : '#666'"
                      opacity="0.6"/>
                    <rect x="3" y="14" width="22" height="8" rx="2"
                      [attr.fill]="labelform.get('position')?.value === p.key ? 'rgba(13,110,253,0.3)' : '#333'"
                      [attr.stroke]="labelform.get('position')?.value === p.key ? '#0d6efd' : '#444'"
                      stroke-width="1.2"/>
                    <rect x="3" y="24" width="22" height="2" rx="1"
                      [attr.fill]="labelform.get('position')?.value === p.key ? '#f88' : '#666'"
                      opacity="0.6"/>
                  </ng-container>

                  <ng-container *ngSwitchCase="'bottom'">
                    <rect x="3" y="2" width="22" height="6" rx="2" fill="#2a2a3a"
                      [attr.stroke]="labelform.get('position')?.value === p.key ? '#6ea8fe' : '#555'"
                      stroke-width="1" stroke-dasharray="2 2"/>
                    <rect x="3" y="10" width="22" height="2" rx="1"
                      [attr.fill]="labelform.get('position')?.value === p.key ? '#f88' : '#666'"
                      opacity="0.6"/>
                    <rect x="3" y="14" width="22" height="8" rx="2"
                      [attr.fill]="labelform.get('position')?.value === p.key ? 'rgba(13,110,253,0.3)' : '#333'"
                      [attr.stroke]="labelform.get('position')?.value === p.key ? '#0d6efd' : '#444'"
                      stroke-width="1.2"/>
                  </ng-container>

                </ng-container>
              </svg>
              <span style="font-size:10px">{{ p.label }}</span>
            </button>
          </div>
        </div>
      </div>
<div class="mb-3">
  <label class="offcanvas-header-text w-100 text-start mb-2">Vertical Size</label>
  <div class="btn-group w-100" role="group">
    <button
      type="button"
      class="btn"
      *ngFor="let option of sizeOptions"
      [class.btn-primary]="labelform.get('vertical').value === option"
      [class.btn-outline-secondary]="labelform.get('vertical').value !== option"
      (click)="changeVertical(option)"
    >
      {{ option }}
    </button>
  </div>
</div>

<div>
  <label class="offcanvas-header-text w-100 text-start mb-2">Horizontal Size</label>
  <div class="btn-group w-100" role="group">
    <button
      type="button"
      class="btn"
      *ngFor="let option of sizeOptions"
      [class.btn-primary]="labelform.get('horizontal').value === option"
      [class.btn-outline-secondary]="labelform.get('horizontal').value !== option"
      (click)="changeHorizontal(option)"
    >
      {{ option }}
    </button>
  </div>
</div>

    </form>
  </div>
</div>
